export const testPasswordContainsUppercaseLetter = (password: string) => {
  const regex = /[A-Z]/;

  return regex.test(password);
};

export const testPasswordContainsLowercaseLetter = (password: string) => {
  const regex = /[a-z]/;

  return regex.test(password);
};

export const testPasswordContainsNumber = (password: string) => {
  const regex = /\d/;

  return regex.test(password);
};

export const testPasswordContainsSpecialCharacter = (password: string) => {
  const regex = /[^\w\s]/;

  return regex.test(password);
};
